import styled from "@emotion/styled";
import { default as FilledCircledDotRaw } from "/public/assets/filled-circled-dot.svg?react";

export const FilledCircledDot = styled(FilledCircledDotRaw)`
  color: var(--tw-blue-500);
`;
